import * as React from "react";
import { BlocksProvider, DevicesProvider } from "@grapesjs/react";
import CustomBlockManager from "./CustomBlockManager";
import { MAIN_BORDER_COLOR, cx } from "./common";
import { ExtraEditorProps } from "../../../pages/CustomPages/CustomPage";
import { Button, FormControl, MenuItem, Select } from "@mui/material";
import { IoArrowBack as IoArrowBackIcon } from "react-icons/io5";

const IoArrowBack = IoArrowBackIcon as React.ElementType;

export default function LeftSidebar({
    className,
    addBlockToRoot,
    filteredCategories,
    page,
}: React.HTMLAttributes<HTMLDivElement> & ExtraEditorProps) {
    return (
        <div className={cx("gjs-right-sidebar flex flex-col", className)}>
            <div
                className={cx(
                    "gjs-top-sidebar flex items-center p-1 gap-3 pl-2",
                    className
                )}
            >
                <Button
                    variant="contained"
                    sx={{
                        minHeight: "38px",
                        minWidth: "30px",
                    }}
                    onClick={() => {
                        window.history.back();
                    }}
                >
                    <IoArrowBack />
                </Button>
                <DevicesProvider>
                    {({ selected, select, devices }) => (
                        <FormControl size="small">
                            <Select
                                value={selected}
                                onChange={(ev) => select(ev.target.value)}
                            >
                                {devices.map((device) => (
                                    <MenuItem value={device.id} key={device.id}>
                                        {device.getName()}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )}
                </DevicesProvider>

                <div className="text-sm font-semibold">{page?.name}</div>
            </div>

            <div
                className={cx(
                    "overflow-y-auto flex-grow border-t",
                    MAIN_BORDER_COLOR
                )}
            >
                <BlocksProvider>
                    {(props) => (
                        <CustomBlockManager
                            addBlockToRoot={addBlockToRoot}
                            filteredCategories={filteredCategories}
                            {...props}
                        />
                    )}
                </BlocksProvider>
            </div>
        </div>
    );
}
